module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp1_6005.bb02b418.png";